import "core-js/modules/es.array.find-index";
import "core-js/modules/es.number.constructor";
import _objectWithoutProperties from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import AppTextField from '@/components/AppTextField.vue';
import AppSelector from '@/components/AppSelector.vue';
import { SnackType } from '@/interfaces/snack';
import { showErrors, showNotification } from '@/utils/snack';
import AuthFilter from '@/mixins/auth-filter';
import { createUser, updateUser, deleteUser } from './gql';

var ManagerDialog = /*#__PURE__*/function (_mixins) {
  _inherits(ManagerDialog, _mixins);

  var _super = _createSuper(ManagerDialog);

  function ManagerDialog() {
    var _this;

    _classCallCheck(this, ManagerDialog);

    _this = _super.apply(this, arguments);
    _this.disableConfirm = false;
    _this.superiorManagerOptions = [];
    _this.deleteDialog = {
      show: false,
      title: '删除',
      text: '确定要删除该管理员？'
    };
    _this.targetManager = null;
    _this.newManagerDialog = {
      show: false,
      disable: false
    };
    _this.managerInput = {
      type: 'new',
      username: '',
      phone: '',
      password: '',
      roleIndex: -1
    };
    _this.managerTypes = {
      ADMIN: '系统管理员',
      ROOT: '超级管理员'
    };
    _this.managerTypeOptions = ['系统管理员', '超级管理员'];
    _this.managerTypeCodes = ['ADMIN', 'ROOT'];
    return _this;
  }

  _createClass(ManagerDialog, [{
    key: "editHandler",
    value: function editHandler(e, user) {
      e.preventDefault();
      e.stopPropagation();
      this.targetManager = user;
      var roleIndex = this.managerTypeCodes.findIndex(function (code) {
        return code === user.role;
      });
      this.managerInput = {
        type: 'edit',
        username: user.username,
        phone: user.phone,
        roleIndex: roleIndex
      };
      this.newManagerDialog.show = true;
    }
  }, {
    key: "deleteHandler",
    value: function deleteHandler(e, manager) {
      e.preventDefault();
      e.stopPropagation();
      this.targetManager = manager;
      this.deleteDialog.text = "\u662F\u5426\u786E\u5B9A\u5220\u9664\u7BA1\u7406\u5458 \u201C".concat(manager.username, "\u201D ?");
      this.deleteDialog.show = true;
    }
  }, {
    key: "newManagerConfirm",
    value: function () {
      var _newManagerConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this$managerInput, username, phone, password, roleIndex, newManagerValid, typedError;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$managerInput = this.managerInput, username = _this$managerInput.username, phone = _this$managerInput.phone, password = _this$managerInput.password, roleIndex = _this$managerInput.roleIndex;
                newManagerValid = this.$refs.form.validate();

                if (newManagerValid) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                this.newManagerDialog.show = false;
                this.newManagerDialog.disable = true;
                _context.prev = 6;
                _context.next = 9;
                return this.$apollo.mutate({
                  mutation: createUser,
                  variables: {
                    input: {
                      username: username,
                      password: password,
                      phone: phone,
                      role: this.managerTypeCodes[roleIndex] || null
                    }
                  }
                });

              case 9:
                showNotification({
                  msg: '管理员添加成功',
                  type: SnackType.Success
                });
                this.clearNewManager();
                this.newManagerDialog.disable = false;
                _context.next = 19;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](6);
                this.newManagerDialog.disable = false;
                typedError = _context.t0;
                showErrors(typedError.graphQLErrors);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 14]]);
      }));

      function newManagerConfirm() {
        return _newManagerConfirm.apply(this, arguments);
      }

      return newManagerConfirm;
    }()
  }, {
    key: "editManagerConfirm",
    value: function () {
      var _editManagerConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$managerInput2, roleIndex, type, rest, targetManager, newManagerValid, managerId, input, key, role, typedError;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$managerInput2 = this.managerInput, roleIndex = _this$managerInput2.roleIndex, type = _this$managerInput2.type, rest = _objectWithoutProperties(_this$managerInput2, ["roleIndex", "type"]);
                targetManager = this.targetManager;
                newManagerValid = this.$refs.form.validate();

                if (!(!newManagerValid || !targetManager || type !== 'edit')) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return");

              case 5:
                managerId = Number(targetManager.id);
                input = {};

                for (key in rest) {
                  if (rest[key] !== targetManager[key]) {
                    input[key] = rest[key];
                  }
                }

                role = this.managerTypeCodes[roleIndex];
                input.role = role;
                this.newManagerDialog.show = false;
                _context2.prev = 11;
                _context2.next = 14;
                return this.$apollo.mutate({
                  mutation: updateUser,
                  variables: {
                    input: input,
                    userId: managerId
                  }
                });

              case 14:
                showNotification({
                  msg: '管理员修改成功',
                  type: SnackType.Success
                });
                this.clearNewManager();
                _context2.next = 22;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](11);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[11, 18]]);
      }));

      function editManagerConfirm() {
        return _editManagerConfirm.apply(this, arguments);
      }

      return editManagerConfirm;
    }()
  }, {
    key: "deleteManagerConfirm",
    value: function () {
      var _deleteManagerConfirm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var id, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                id = this.targetManager.id;
                this.deleteDialog.show = false;
                _context3.prev = 2;
                _context3.next = 5;
                return this.$apollo.mutate({
                  mutation: deleteUser,
                  variables: {
                    userId: +id
                  }
                });

              case 5:
                showNotification({
                  msg: '管理员删除成功',
                  type: SnackType.Success
                });
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 8]]);
      }));

      function deleteManagerConfirm() {
        return _deleteManagerConfirm.apply(this, arguments);
      }

      return deleteManagerConfirm;
    }()
  }, {
    key: "clearNewManager",
    value: function clearNewManager() {
      this.managerInput = {
        type: 'new',
        username: '',
        phone: '',
        password: '',
        roleIndex: -1
      };
    }
  }]);

  return ManagerDialog;
}(mixins(AuthFilter));

ManagerDialog = __decorate([Component({
  components: {
    AppTextField: AppTextField,
    AppSelector: AppSelector
  }
})], ManagerDialog);
export default ManagerDialog;